import React from 'react';
import { Check } from 'lucide-react';
import { Button } from './ui/Button';
import { Card } from './ui/Card';
export function PricingSection() {
  const features = ['Federal + State returns included', 'Prepared by a CPA or Enrolled Agent', 'Professional document review', 'Secure digital upload system', 'Personalized email support', 'Quick turnaround time'];
  return <section className="py-24 bg-accent/20" data-id="element-162">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-163">
        <div className="max-w-4xl mx-auto text-center mb-12" data-id="element-164">
          <h2 className="text-3xl md:text-4xl font-bold text-primary-dark mb-4" data-id="element-165">
            Simple, Transparent Pricing
          </h2>
          <p className="text-lg text-neutral-600" data-id="element-166">
            Professional tax preparation without the hourly billing anxiety.
          </p>
        </div>

        <div className="max-w-lg mx-auto" data-id="element-167">
          <Card className="relative overflow-hidden border-2 border-secondary/30" data-id="element-168">
            <div className="absolute top-0 left-0 right-0 h-2 bg-coastal-gradient" data-id="element-169" />

            <div className="p-8 sm:p-10 text-center" data-id="element-170">
              <h3 className="text-2xl font-bold text-neutral-800 mb-2" data-id="element-171">
                Tax Preparation
              </h3>
              <div className="flex items-baseline justify-center my-6" data-id="element-172">
                <span className="text-xl text-neutral-500 mr-2" data-id="element-173">
                  Starting at
                </span>
                <span className="text-5xl font-bold text-primary-dark" data-id="element-174">
                  $250
                </span>
              </div>

              <p className="text-neutral-600 mb-8" data-id="element-175">
                A complete, flat-rate solution for most young professionals and
                simple tax situations.
              </p>

              <ul className="text-left space-y-4 mb-10" data-id="element-176">
                {features.map((feature, i) => <li key={i} className="flex items-start" data-id="element-177">
                    <div className="flex-shrink-0 w-6 h-6 rounded-full bg-secondary-light/30 flex items-center justify-center mr-3 mt-0.5" data-id="element-178">
                      <Check className="w-3.5 h-3.5 text-secondary-dark" data-id="element-179" />
                    </div>
                    <span className="text-neutral-700" data-id="element-180">{feature}</span>
                  </li>)}
              </ul>

              <Button size="lg" className="w-full shadow-lg shadow-primary/20" onClick={() => document.getElementById('intake-form')?.scrollIntoView({
              behavior: 'smooth'
            })} data-id="element-181">
                Begin Intake
              </Button>

              <p className="mt-4 text-xs text-neutral-400" data-id="element-182">
                Complex returns (business income, multiple states, etc.) may
                incur additional fees. We'll always quote you upfront.
              </p>
            </div>
          </Card>
        </div>
      </div>
    </section>;
}